module.exports = "<span\n  [class.limit-exceeded]=\"count > limit\"\n>{{ 'max_length_counter.message' | translate: { count: count, limit: limit } }}</span>\n"